import { createFileRoute } from "@tanstack/react-router";

import CampaignDetail from "@/components/organisms/campaigns/detail/CampaignDetail";

const CampaignDetailPage = () => {
  const { campaignId } = Route.useParams();

  return <CampaignDetail campaignId={campaignId} />;
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/campaign/$campaignId/detail")({
  component: CampaignDetailPage,
});
